import { jsx as l } from "react/jsx-runtime";
import { ListBoxSelect as n, Tooltip as b } from "@systemeio/ui";
import { useEditorState as m } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as u } from "react";
import { ToolbarSelectButton as d } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as c } from "../../constants/default-styles.mjs";
import { useTranslation as f } from "../../i18n.mjs";
const I = (i, r) => {
  const { t: s } = f(), a = m({
    editor: i,
    selector: ({ editor: e }) => ({
      isEditable: (e == null ? void 0 : e.options.editable) ?? !1
    })
  }), t = !(a != null && a.isEditable);
  return u(() => {
    const e = (o) => {
      if (!i) return null;
      o && i.chain().focus().insertContent(o).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ l(
        n,
        {
          value: void 0,
          disabled: t,
          data: r,
          onChange: e,
          children: (o) => /* @__PURE__ */ l(
            b,
            {
              disabled: t,
              label: s("substitute_variables"),
              anchor: "left",
              ...c,
              children: /* @__PURE__ */ l(d, { open: o, disabled: t, children: s("substitutions") })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ l(
        n,
        {
          optionsClassName: "z-40",
          value: void 0,
          disabled: t,
          data: r,
          onChange: e,
          children: (o) => /* @__PURE__ */ l(
            b,
            {
              disabled: t,
              label: s("substitute_variables"),
              anchor: "left",
              ...c,
              children: /* @__PURE__ */ l(d, { open: o, disabled: t, children: s("substitutions") })
            }
          )
        }
      )
    };
  }, [i, t, r, s]);
};
export {
  I as useSubstitutesExtensionToolbar
};
